import { PARKING_TYPE_MAP, TRoomDetail } from '@/entities/room'
import { ContentBox } from '@/shared/ui'

import { Heading, Item, Label, List, Value } from '../common'

export type Props = Pick<
  TRoomDetail,
  'hasElevator' | 'parkingType' | 'parkingNotice'
>

export const Facilities = ({
  hasElevator,
  parkingType,
  parkingNotice,
}: Props) => {
  return (
    <section className="space-y-10">
      <div className="w-[260px] space-y-5">
        <Heading>엘리베이터 및 주차</Heading>
        <List spacing="medium" className="typo-body2 text-gray-900">
          <Item className="justify-between">
            <Label icon="elevator" className="font-semibold">
              엘리베이터
            </Label>
            <Value>{hasElevator ? '있음' : '없음'}</Value>
          </Item>
          <Item className="justify-between">
            <Label icon="parking" className="font-semibold">
              주차
            </Label>
            <Value>{PARKING_TYPE_MAP[parkingType]}</Value>
          </Item>
        </List>
      </div>

      {parkingNotice && (
        <ContentBox spacing="medium" color="light-gray" className="space-y-2">
          <h4 className="typo-label1 font-semibold text-gray-900">주차 안내</h4>
          <div className="typo-label2 font-normal whitespace-break-spaces text-gray-500">
            {parkingNotice}
          </div>
        </ContentBox>
      )}
    </section>
  )
}
